<template>
  <!-- 用户设置 -->
  <div class="account">
    <div v-if="!PCshow">
      <p class="msg">weChatAppID：{{weChatAppID}}</p>
      <p class="msg">weChatAppSecret：{{weChatAppSecret}}</p>
      <p class="msg">weChatToken：{{weChatToken}}</p>
      <p class="msg">weChatEncodingAESKey：{{weChatEncodingAESKey}}</p>
      <van-cell-group>
        <van-switch-cell v-model="checked" @change="edit" title="是否开启微信扫一扫：" />
      </van-cell-group>
    </div>
    <div v-if="PCshow">
      <p class="msg">您未在PC上设置微信信息</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checked: true,
      weChatAppID: "",
      weChatAppSecret: "",
      weChatToken: "",
      weChatEncodingAESKey: "",
      isWebChatLogin: null,
      weChatID: 0,
      weChatAccessToken: "",
      PCshow: true
    };
  },
  created() {
    this.getSys();
  },
  methods: {
    async getSys() {
      let res = await this.xyapi.get(
        this.xyMApi + "/api/WeChat/GetAll"
      );
      if (res.success) {
        if (res.data === null || res.data.WeChatID === 0) {
          this.PCshow = false;
        }else{
          this.PCshow = true;
          this.weChatAppID = res.data.WeChatAppID;
          this.weChatAppSecret = res.data.WeChatAppSecret;
          this.weChatToken = res.data.WeChatToken;
          this.weChatEncodingAESKey = res.data.WeChatEncodingAESKey;
          this.isWebChatLogin = res.data.IsWebChatLogin;
          this.weChatID = res.data.WeChatID;
          this.weChatAccessToken = res.data.WeChatAccessToken;
        }
      }
    },
    async edit() {
      let res = await this.xyapi.post(
        this.xyMApi + "/api/WeChat/Edit",
        {
          WeChatAppID: this.weChatAppID,
          WeChatAppSecret: this.weChatAppSecret,
          WeChatToken: this.weChatToken,
          WeChatEncodingAESKey: this.weChatEncodingAESKey,
          IsWebChatLogin: this.isWebChatLogin,
          WeChatID: this.weChatID,
          WeChatAccessToken: this.weChatAccessToken
        }
      );
      console.log(res);
    }
  }
};
</script>
<style lang="less" scoped>
.account {
  text-indent: 3%;
  .msg {
    display: block;
    height: 100px;
    line-height: 100px;
    background-color: #fff;
    margin-bottom: 15px;
    font-size: 28px;
    color: #555;
  }
}
</style>